import React, { useState } from 'react'
import { Card, useAlerts } from '@theneatcompany/nui'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { Text } from '../../common'
import Form from '../../forms/Form'
import InputField from '../../forms/InputField'
import { Column, Row } from '../../layout'
import Yup from '../../../utils/yup'
import { extractMessage } from '../../../utils/errors'
import usePathnameChange from '../../../hooks/usePathnameChange'
import { sendError } from '../../../utils/rollbar'
import { NEWSLETTER_FORM } from '../../../env'

const FormResetter = () => {
  const { reset } = useFormContext()
  usePathnameChange(reset)
  return null
}

// Each site tags its sign-ups with its own lead source.
export default function MailingListOptInForm({
  source, emailOnly = false, buttonMessageId = 'cta.subscribe', buttonVariant = 'secondary',
}) {
  const [succeeded, setSucceeded] = useState(false)
  const alerts = useAlerts()
  usePathnameChange(() => succeeded && setSucceeded(false))
  const schema = Yup.object({
    email: Yup.string().trim().lowercase().email()
      .required(),
    ...!emailOnly ? {
      firstName: Yup.string().trim().required(),
      lastName: Yup.string().trim().required(),
    } : {},
  })

  const handleSubmit = async (model) => {
    const formData = new FormData()
    const values = schema.cast(model)
    if (!emailOnly) {
      formData.append(NEWSLETTER_FORM.fields.firstName, values.firstName)
      formData.append(NEWSLETTER_FORM.fields.lastName, values.lastName)
    }
    formData.append(NEWSLETTER_FORM.fields.email, values.email)
    formData.append(NEWSLETTER_FORM.fields.env, process.env.NEXT_PUBLIC_ENV)

    try {
      await fetch('/api/lead/create', {
        method: 'POST',
        body: JSON.stringify({ ...values, source }),
      })
    } catch (error) {
      sendError(error, 'Failed to create lead: Mailing List')
    }

    try {
      await fetch(NEWSLETTER_FORM.url, {
        method: 'POST',
        mode: 'no-cors',
        body: formData,
      })
      setSucceeded(true)
    } catch (err) {
      alerts.error(extractMessage(err))
    }
  }
  return succeeded ? (
    <Card intent="success">
      <Text.P messageId="pages.emailPreferences.subscribe.success" />
    </Card>
  ) : (
    <Form
      initialValues={{ firstName: '', lastName: '', email: '' }}
      onSubmit={handleSubmit}
      options={{ mode: 'all' }}
      schema={schema}
    >
      {!emailOnly && (
        <Row gap={16} mobileBreakpoint="small" noMobileGap>
          <Column>
            <InputField ignoreTouched={false} labelProps={{ hidden: true }} name="firstName" />
          </Column>
          <Column>
            <InputField ignoreTouched={false} labelProps={{ hidden: true }} name="lastName" />
          </Column>
        </Row>)}
      <Row>
        <Column>
          <InputField
            autoComplete="email"
            ignoreTouched={false}
            indicateValid
            labelProps={{ hidden: true }}
            name="email"
          />
        </Column>
      </Row>
      <Form.Action
        messageId={buttonMessageId}
        submittingMessageId="cta.processing"
        type="submit"
        variant={buttonVariant}
      />
      <FormResetter />
    </Form>
  )
}

MailingListOptInForm.propTypes = {
  source: PropTypes.string.isRequired,
  emailOnly: PropTypes.bool,
  buttonMessageId: PropTypes.string,
  buttonVariant: PropTypes.string,
}
